export default Object.freeze({
    MONEY: 'money',
    PERCENTAGE: 'percentage',
    STRING: 'string',
    NUMBER: 'number',
    DATE: 'date',
    COMBO: 'combo',
});
